import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { interpolateString } from 'ctm-util-functions';

/**
 * Displays a Text Component with interpolated template
 * @type {Object} label Label text template
 * @type {Object} product product to be passed into the template
 * @returns {FeatureFilteredOutText} A FeatureFilteredOutText Component
 */
class FeatureFilteredOutText extends PureComponent {

    /**
     * Finds {stateKey} in a string and returns the string along with content replaced from state.
     * @param {String} label Label text with replacement stateKey
     * @param {Object} product Product from stateProps
     * @returns {String} Label string with replaced content
     */
    getLabel = (label, product) => {
        return interpolateString(label || '')(product);
    };

    render = () => {
        const { label, stateProps } = this.props;
        const { product } = stateProps;
        return (
            <span>{this.getLabel(label, product)}</span>
        );
    };

}

FeatureFilteredOutText.propTypes = {
    label: PropTypes.string,
    stateProps: PropTypes.shape({
        product: PropTypes.object.isRequired
    })
};

export { FeatureFilteredOutText };
